import { PrivatPage } from '../components/pages'

export default PrivatPage
